import { FormTemplate } from 'data/template/template.types';

// eslint-disable-next-line import/prefer-default-export
export const xdpTemplate: FormTemplate = {
  version: '1.0.0',
  name: 'TLS Profile',
  key: 'tlsProfile',
  main: {
    metadata: {
      layout: {
        rows: [
          ['id'],
          ['ipduId', 'ipAddr', 'port'],
          ['nodeName', 'insideNat', '$empty'],
          ['incomingTrafficRange', '$empty', '$empty'],
          ['inPortStart', 'inPortEnd', '$empty'],
          ['outgoingTrafficRange', '$empty', '$empty'],
          ['outPortStart', 'outPortEnd', '$empty'],
        ],
      },
    },
    fields: {
      id: {
        type: 'text',
        hide: 'true',
        initial: '',
      },
      ipduId: {
        label: 'XDP ID',
        type: 'text',
        initial: '',
        validation: {
          required: true,
          validators: [
            {
              type: 'length',
              length: 2,
            },
            {
              type: 'Interval',
              intervals: [
                [
                  0,
                  65,
                ],
              ],
              errorMessage: 'Must be between 0 - 65. Please re-enter.',
            },
          ],
        },
      },
      ipAddr: {
        label: 'AF IP Address',
        type: 'text',
        initial: '',
        validation: {
          required: true,
          validators: [
            {
              type: 'length',
              length: 42,
            },
            {
              type: 'IPAddress',
              errorMessage: 'Must be a valid IP Address. Please re-enter.',
            },
          ],
        },
      },
      port: {
        label: 'Port',
        hintMessage: 'The value must be greater than 1023',
        type: 'text',
        initial: '',
        validation: {
          validators: [
            {
              type: 'length',
              length: 5,
            },
            {
              type: 'Interval',
              intervals: [
                [
                  1023,
                  65535,
                ],
              ],
              errorMessage: 'Must be between 1023 - 65536. Please re-enter.',
            },
          ],
        },
      },
      nodeName: {
        label: 'Node Name',
        type: 'select',
        initial: '',
        options: [
          {
            label: 'Select a Node',
            value: ''
          }
        ]
      },
      insideNat: {
        label: 'Xcipio is behind NAT',
        type: 'checkbox',
        initial: false,
      },
      inPortStart: {
        label: 'Starting Port Number',
        type: 'text',
        initial: '',
        validation: {
          validators: [
            {
              type: 'length',
              length: 5,
            },
            {
              type: 'Interval',
              intervals: [
                [
                  0,
                  65535,
                ],
              ],
              errorMessage: 'Must be between 0 - 65536. Please re-enter.',
            },
          ],
        },
      },
      inPortEnd: {
        label: 'Ending Port Number',
        type: 'text',
        initial: '',
        validation: {
          required: true,
          validators: [
            {
              type: 'length',
              length: 5,
            },
            {
              type: 'Interval',
              intervals: [
                [
                  0,
                  65535,
                ],
              ],
              errorMessage: 'Must be between 0 - 65536. Please re-enter.',
            },
          ],
        },
      },
      outPortStart: {
        label: 'Starting Port Number',
        type: 'text',
        initial: '',
        validation: {
          validators: [
            {
              type: 'length',
              length: 5,
            },
            {
              type: 'Interval',
              intervals: [
                [
                  0,
                  65535,
                ],
              ],
              errorMessage: 'Must be between 0 - 65536. Please re-enter.',
            },
          ],
        },
      },
      outPortEnd: {
        label: 'Ending Port Number',
        type: 'text',
        initial: '',
        validation: {
          required: true,
          validators: [
            {
              type: 'length',
              length: 5,
            },
            {
              type: 'Interval',
              intervals: [
                [
                  0,
                  65535,
                ],
              ],
              errorMessage: 'Must be between 0 - 65536. Please re-enter.',
            },
          ],
        },
      },
      incomingTrafficRange: {
        type: 'custom',
        initial: 'Incoming Traffic Range',
        customComponent: 'privateKey',
        className: 'section-label',
      },
      outgoingTrafficRange: {
        type: 'custom',
        initial: 'Outgoing Traffic Range',
        customComponent: 'certificate',
        className: 'section-label',
      },
    },
  },
};
